import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { Table, TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { Tag, TagService } from '../../shared/public-api';

@Component({
  selector: 'admin-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss'],
  imports: [
    CommonModule,
    InputTextModule,
    TableModule,
    ConfirmDialogModule,
    ButtonModule,
    DialogModule,
    FormsModule,
  ],
  providers: [ConfirmationService],
})
export class TagsComponent implements OnInit {
  @ViewChild('dt') dataTable: Table;
  update = false;
  tags: Observable<Tag[]>;
  tagModel: Tag;
  updateTagModel: Tag;

  constructor(
    private readonly tagService: TagService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.tagModel = new Tag();
    this.tags = this.tagService.getTags();
  }

  createTag(): void {
    this.tagService.createTag(this.tagModel).subscribe(() => {
      this.tags = this.tagService.getTags();
      this.tagModel = new Tag();
    });
  }

  updateTag(tag: Tag): void {
    this.updateTagModel = Object.assign({}, tag);
    this.update = true;
  }

  saveTag(): void {
    this.update = false;
    this.tagService.updateTag(this.updateTagModel).subscribe(() => {
      this.tags = this.tagService.getTags();
      this.tagModel = new Tag();
    });
  }

  deleteTag(tag: Tag): void {
    this.confirmationService.confirm({
      message: 'Etes-vous sur de supprimer ce tag?',
      header: 'Supprimer un tag',
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.removeTag(tag),
    });
  }

  searchTag(target: EventTarget): void {
    const value = (target as HTMLInputElement).value;
    this.dataTable.filterGlobal(value, 'contains');
  }

  private removeTag(tag: Tag): void {
    this.tagService.deleteTag(tag.id).subscribe(() => (this.tags = this.tagService.getTags()));
  }
}
